import { config } from "../_config";
import { authHeader, handleResponse } from "../_helpers";

export const caninesService = {
  getAll,
  getById,
  update
};

function getAll() {
  const requestOptions = {
    method: "GET",
    headers: authHeader()
  };

  return fetch(`${config.apiUrl}/canines`, requestOptions).then(handleResponse);
}

function getById(id) {
  const requestOptions = {
    method: "GET",
    headers: authHeader()
  };

  return fetch(`${config.apiUrl}/canines/${id}`, requestOptions).then(
    handleResponse
  );
}

function update(canine) {
  const requestOptions = {
    method: "PUT",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(canine)
  };

  return fetch(`${config.apiUrl}/canines/${canine.id}`, requestOptions).then(
    handleResponse
  );
}